<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div>
        <el-input
          v-model="objr.order_id"
          style="width:200px;margin-right:10px"
          placeholder="请输入订单ID"
        />
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="awered"
        >重置</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="addbit"
        >新增</el-button>
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="order_id"
        label="订单ID"
        width="300"
        align="center"
      />
      <el-table-column
        prop="quantity_used"
        label="已经使用数量"
        align="center"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteItem(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      :page-sizes="[10]"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
    <el-dialog
      :title="adtype === 1 ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="25%"
    >
      <readingcreatedialog
        ref="readingcreateview"
        @updatawe="updatawe"
      />
    </el-dialog>
  </div>
</template>

<script>
import readingcreatedialog from './components/readingcreatedialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { adxaccountlistbianse, adxaccountdelbianse } from '@/api/report/adx'
export default {
  components: {
    readingcreatedialog,
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        order_id: ''
        // name: null
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      options: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: 'ADX'
        },
        {
          value: 2,
          label: '变色龙'
        }
      ]
    }
  },
  created() {
    this.menuList()
  },
  mounted() {},
  methods: {
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await adxaccountlistbianse(this.objr)
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      // this.objr.pageSize = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.order_id = ''
      // this.objr.name = ''
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      this.adtype = 2
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(2, item)
      }, 100)
    },
    // 删除
    async deleteItem(row) {
      this.$confirm('是否确定删除该条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await adxaccountdelbianse({ id: row.id })
        this.menuList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
